import { Component, OnInit, OnDestroy, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";

import { AdjustmentArchive } from "./vibe-history/vibe-history.component";
import { ApiService, } from "src/app/api.service";
import { ItemHealth } from "src/app/item-health";
import { PreventNavIfSelectedDirective } from "src/app/prevent-nav-if-selected.directive";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-rtb",
	templateUrl: "./rtb.component.html",
	styleUrls: ["./rtb.component.scss"],
	imports: [FormsModule, RouterLink, RouterLinkActive, PreventNavIfSelectedDirective, RouterOutlet]
})
export class RtbComponent implements OnInit, OnDestroy {
	private api = inject(ApiService);
	private router = inject(Router);
	private route = inject(ActivatedRoute);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;

	public rotors: APIResults.Rotor[];
	public selectedRotor?: APIResults.Rotor;
	public adjustmentArchive: AdjustmentArchive;
	public regimes: APIResults.RegimeIndex;
	public vibecheck: APIResults.VibeCheck;
	public vibecheckstatus: number;
	public absCheck: APIResults.AbsCheck;

	public ItemHealth = ItemHealth;

	async ngOnInit(): Promise<void> {
		const { rotors, regimes, check, checkstatus, abscheck } = await this.api.GetRTBConfig(this.asset.asset_id);
		this.rotors = rotors;
		this.regimes = regimes;
		this.vibecheck = check;
		this.vibecheckstatus = checkstatus;
		this.absCheck = abscheck;
		if (this.rotors.length > 0) {
			this.rotorChange(this.rotors[0]);
		} else {
			this.rotorChange(undefined);
		}
	}

	ngOnDestroy(): void {
		this.adjustmentSubscription?.unsubscribe();
	}

	private activeRouteComponent: any;
	async rotorChange(rotor?: APIResults.Rotor) {
		this.adjustmentArchive = undefined;
		this.selectedRotor = rotor;
		if (this.activeRouteComponent) {
			this.activeRouteComponent.rotor = this.selectedRotor;
			if (this.activeRouteComponent.rotorChange) this.activeRouteComponent.rotorChange();
		}
	}

	private adjustmentSubscription: any;
	public updateRouterOutlet(routecomponent?: any) {
		if (routecomponent) {
			this.activeRouteComponent = routecomponent;
		}
		if (this.adjustmentSubscription) {
			this.adjustmentSubscription.unsubscribe();
			this.adjustmentSubscription = null;
		}
		if (this.activeRouteComponent) {
			this.activeRouteComponent.asset = this.asset;
			this.activeRouteComponent.fleet = this.fleet;
			this.activeRouteComponent.rotor = this.selectedRotor;
			this.activeRouteComponent.regimeConfigs = this.regimes;
			this.activeRouteComponent.vibecheck = this.vibecheck;
			this.activeRouteComponent.absCheck = this.absCheck;
			this.activeRouteComponent.archive = this.adjustmentArchive;
			if (this.activeRouteComponent.recordAdjustment) {
				this.adjustmentSubscription = this.activeRouteComponent.recordAdjustment.subscribe((archive: AdjustmentArchive) => {
					this.adjustmentArchive = archive;
					this.router.navigate(["vibe-history"], { relativeTo: this.route });
				});
			}
		}
	}
}

